import styled from "styled-components";
export const ReportsWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
